/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 13th 2022, 12:13:33 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { CUSTOMER_SERVICE_EMAIL } from "config";
import { XButtonIcon } from "theme/icons";
import { FullScreenNotificationGrid } from "ui-widgets";

export const UnavailableOrganizationAlert = ({ organizationName }) => {
  return (
    <FullScreenNotificationGrid
      pageTitle={<>Unavailable Organization</>}
      pageContent={
        <p>
          Your organization, {organizationName}, is no longer available on Onestop. This is due to a breach of our terms
          and conditions or lack of sufficient KYC information to be able to vet your organization for compliance. If
          you feel this is a mistake, kindly reach out to our compliance team at{" "}
          <a href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>{CUSTOMER_SERVICE_EMAIL}</a>
        </p>
      }
      pageIllustration={<XButtonIcon height={256} width={256} />}
    />
  );
};
